import type { ColumnFilter, ColumnFilters } from '../filters';
import type { LocatesV2ColumnId } from 'src/routes/widgets/LocatesV2Widget/columns';

export const addColumnFilter = (columnId: LocatesV2ColumnId, filter: ColumnFilter) =>
    ({ type: 'add', columnId, filter }) as const;
export const removeColumnFilter = (columnId: LocatesV2ColumnId, filter: ColumnFilter) =>
    ({ type: 'remove', columnId, filter }) as const;
export const clearColumnFilter = (columnId: LocatesV2ColumnId) => ({ type: 'clear', columnId }) as const;
export const clearAllColumnFilters = () => ({ type: 'clearAll' }) as const;

type Action = ReturnType<
    typeof addColumnFilter | typeof removeColumnFilter | typeof clearColumnFilter | typeof clearAllColumnFilters
>;

function sameFilter(a: ColumnFilter, b: ColumnFilter): boolean {
    return a.mode === b.mode && a.value.trim().toLowerCase() === b.value.trim().toLowerCase();
}

export function columnFilterReducer(state: ColumnFilters, action: Action): ColumnFilters {
    if (action.type === 'clearAll') return Object.keys(state).length ? {} : state;
    const terms = state[action.columnId] ?? [];
    switch (action.type) {
        case 'add': {
            const value = action.filter.value.trim();
            if (!value || terms.some((term) => sameFilter(term, action.filter))) return state;
            return { ...state, [action.columnId]: [...terms, { ...action.filter, value }] };
        }
        case 'remove': {
            const remaining = terms.filter((term) => !sameFilter(term, action.filter));
            if (remaining.length === terms.length) return state;
            if (remaining.length) return { ...state, [action.columnId]: remaining };
            return columnFilterReducer(state, clearColumnFilter(action.columnId));
        }
        case 'clear': {
            if (!(action.columnId in state)) return state;
            const next = { ...state };
            delete next[action.columnId];
            return next;
        }
    }
}
